module.exports = __webpack_public_path__ + "img/preview-11.3ea3a636.png";